export const visit = (vm, at) => {
at({ "en": { "recommendedSalesFooter": { "title": "Not ready to buy?<br>Try Sales Hub Professional <b>FREE</b> with our 14-day trial.", "trialButton": "Start a free 14-day trial" } } });
};